<template>
  <div>
    <div class="bp_list" v-if="ready.bauprojekte">
      <router-link :to="'/admin/dashboard/bauprojekte/' + bp.id" class="bp_list_item card" v-for="bp in bauprojekte" :key="bp.id">
        <div
          class="bp_list_item_content card-body"
        >
        <div class="bp_list_header" 
          v-bind:style="[bp.extended && bp.extended.logo && bp.extended.logo.thumbnails[3].url ? { 'background-image': 'url(' + bp.extended.logo.thumbnails[3].url + ')' } : {}]"
          ></div>
          <div class="bp_list_item_information">
            <h4>{{ bp.name }}</h4>
            <p>{{ bp.ort }}</p>
            <!--<p>{{ bp.strasse }}</p>-->
          </div>
        </div>

        
      </router-link>
      <div class="addBp card" @click="openModal">
        <feather size="80" type="plus"></feather>
      </div>
    </div>
    <b-modal ref="addBpModal" size="md" id="addBpModal" title="Neues Bauprojekt" cancel-disabled ok-disabled>
          <div class="col-12">
       
                <div class="form-container">
                  <label>Name*</label>
                  <b-input-group class="form-input-group" prepend="Abc">
                    <b-form-input
                      class="form-control"
                      name="modal_name"
                      v-model="modal_name"
                      v-bind:class="{ form_error: hasError('modal_name') }"
                      @blur="validate"                      
                    ></b-form-input>
                    <feather type="check" v-if="!hasError('modal_name')" name="modal_name" class="checkmark"></feather>
                    <feather type="x" v-if="hasError('modal_name')" name="modal_name" class="failmark"></feather> 
                  </b-input-group>                  
     
      
        </div>
      </div>
      <template slot="modal-footer">
        <b-button @click="closeModal">Abbrechen</b-button>
        <b-button @click="createBp" :disabled="validation_errors.length == 0 && modal_name.length > 3  ? false : true">Erstellen</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminBauprojekte",
  components: {},
  data() {
    return {
      validation_errors: [],
      modal_name: "",
    };
  },
  computed: {
    ...mapGetters({
      apiSettings: "auth/apiSettings",
      user: "auth/user",
      bauprojekte: "app/bauprojekte",
      ready: "app/readyState",
      animations: "app/animations",
      toast: "app/toasts"
    }),
  },
  created: async function() {
    if (this.bauprojekte == false) {
      try {
        await this.$store.dispatch("app/apiGetBauprojekte");
      } catch (error) {
        console.log(error);
      }
    }
  },
  methods: {
    openModal() {
      this.$bvModal.show("addBpModal");
      this.validation_once = false;
    },
    closeModal() {
      this.$bvModal.hide("addBpModal");
      this.resetModal();
    },
    resetModal() {
      this.validation_errors = [];
      this.modal_name = "";
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async validate(field) {
      if(!this.validation_once) this.validation_once = true;
      const fieldName = field.target.name.indexOf("modal_") > -1 ? field.target.name.split("modal_")[1] : field.target.name;
      const errorExists = this.validation_errors.indexOf(field.target.name);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);

      const validationPayload = {
        context: "bauprojekt",
        field: fieldName,
        value: this[field.target.name],
      };

      const validationResult = await this.$store.dispatch("app/validateField", validationPayload);
      if(!validationResult) 
      {
        this.validation_errors.push(field.target.name);
        return;
      }      
    },
    async createBp() {
      try {
        const createPayload = {
          collection: "bauprojekt",
          item: {
            name: this.modal_name,
            status: "published"
          }
        }
        const response = await this.$store.dispatch("app/createBauprojekt", createPayload);
        const updatePayload = {
          resource: "bauprojekt",
          id: response.data.id,
        }
        await this.$store.dispatch("app/updateSingle", updatePayload);
        this.$router.push("/admin/dashboard/bauprojekte/" + response.data.id);
      } catch(error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen des Bauprojekts", this.toast.failure); 
        this.closeModal();
      }
    },    
  },
};
</script>

<style>
.addBp,
.addBp-small {
  align-items: center;
  vertical-align: bottom;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.addBp:hover,
.addBp-small:hover {
  color: white;
  background: grey;
  transition: all 0.5s;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
}
.bp_list_item:hover .bp_list_header {
    background-size: 120% auto;
}
.bp_list_header {
    height: 180px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center center;
      transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.addBp,
.bp_list_item {
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  will-change: transform;
  -webkit-perspective: 1000;
  position: relative;
  z-index: 5;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  width: 20%;
  min-width: 280px !important;
  max-width: 340px !important;
  margin: 10px;
  border: 3px solid grey;
}

.addBp-small {
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  will-change: transform;
  -webkit-perspective: 1000;
  position: relative;
  z-index: 5;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  border: 3px solid grey;
  width: 100px;
  margin: auto;
}

.bp_list_item {
  display: inline-flex;
  flex-flow: column;
}

.bp_list_item_content {
  position: relative;
  height: 100%;
  padding: 0px !important;
  background-size: cover;
  background-repeat: none;
}
.bp_list {
  display: inline-flex;
  align-items: left;
  justify-content: left;
  flex-flow: row;
  flex-wrap: wrap !important;
      width: 100%;
}

/*.editButton {
  position: absolute;
  background: white;
  bottom: 0px;
  z-index: 10;
  width: 100%;
  border-top: 2px solid grey;
  transition: all 0.5s;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 20%;
  opacity: 0;
  cursor: pointer;
}

.bp_list_item:hover .editButton {
  opacity: 1;
}*/

.bp_list_item_information {
    padding: 16px 25px;
    min-height: 120px;
}
.bp_list_item_information h4 {
    margin-bottom: 8px;
    font-weight: 700;
}
.form-group {
  position: relative;
}

.checkmark {
  color: green;
}

.failmark {
  color: red;
}

.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark,
.failmark {
  position: absolute;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark.select,
.loader.select {
  right: 30px;
  z-index: 1000;
}
</style>
